import script from "./ProductShowcase.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductShowcase.vue?vue&type=script&setup=true&lang=js"

import "./ProductShowcase.vue?vue&type=style&index=0&id=86cc469c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86cc469c"]])

export default __exports__